<template>
    <div class="header xxx" >
        <div>
            <div ><i @click="goTodevicesList" class="iconfont icon-fanhui1"></i></div>
            <div class="logo ">
                <p v-if="router==='temp'">{{`${deviceInfo.name}${dtuID?dtuID:''}`}} </p>
                <p v-if="router==='user'">{{`设备列表`}} </p>
            </div>

            <div class="iconfont">
                <div class="user-info tool-tip" style="display:flex">
                    <div class="msg-tool-button" v-if="userInfo.identity==='USER'">
                        <div v-if="!isMobile" class="toggleMsgTool" size="small" @click="toggleMsgTool" >
                            {{msgTool.show ? '关闭' : '发送短消息'}}
                        </div>
                        <i v-else @click="toggleMsgTool" style="font-size: 25px;" class="iconfont icon-youjian">
                        </i>
                        <transition name="el-zoom-in-top">
                            <div  v-if="msgTool.show" class="msg-tool">
                                <div class="msg-tool-input">
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        placeholder="请输入内容"
                                        :maxlength="64"
                                        v-model="msgTool.msg">
                                    </el-input>
                                </div>
                                <div>
                                    <p @click="setDeviceMsg "><el-button :loading="msgTool.loading" type="text">{{msgTool.loading?'正在发送':'发送'}}</el-button></p>
                                </div>
                            </div>
                        </transition>
                    </div>



                    <template v-if="userInfo.identity!=='USER'">
                        <!--<svg @click="msgMenu.show=!msgMenu.show" class="icon" aria-hidden="true"-->
                             <!--style="stroke: white; fill: white;width:0.28rem;height:0.28rem">-->
                            <!--<use xlink:href="#icon-tixing"></use>-->
                        <!--</svg>-->

                    </template>
                </div>

            </div>

        </div>
        <transition name="el-zoom-in-top">
            <div v-show="msgMenu.show" class="msg-menu">
                <!-- <msg-menu></msg-menu> -->
            </div>
        </transition>
    </div>

</template>

<script>
    import { mapState } from "vuex";
    import Lib from "../../lib/lib";
    import msgMenu from "../../components/tempControl/msgMenu.vue";

    export default {
        name: "pageHead",
        components: {
            msgMenu
        },
        data() {
            return {
                activeIndex: "timeCharts",
                msgMenu: {
                    show: false
                },
                clientWidth: document.body.clientWidth,
                router: "",
                msgTool: {
                    show: false,
                    msg: "",
                    sys_alias: "1",
                    loading: false
                }
            };
        },
        watch: {
            $route: "showRouteName"
        },
        computed: {
            ...mapState({
                isMobile: state => state.isMobile,
                userInfo: state => state.userInfo,
                deviceInfo: state => state.deviceInfo,
                isOpen: state => {
                    return state.siderbarOpen;
                }
            }),

            dtuID(){
                return this.deviceInfo.device_sn.split('LMSZ')[1]
            }
        },
        mounted() {
            // 监听窗口变化

            this.showRouteName();
        },
        methods: {
            goTodevicesList(){
              this.$router.push('/user/deviceList?sider=true')
            },
            showRouteName() {
                if (this.$route.path.search("user") === -1) {
                    this.router = "temp";
                } else {
                    this.router = "user";
                }
            },
            toggleSide() {
                this.$store.dispatch("toggleSide");
            },
            toggleMsgTool() {
                let msgTool = this.msgTool;
                msgTool.show = !msgTool.show;
            },
            setDeviceMsg() {
                this.msgTool.loading = true;
                let params = {
                    payload: JSON.stringify({
                        msg: this.msgTool.msg,
                        devNo: this.msgTool.sys_alias * 1
                    }),
                    sys_alias: this.msgTool.sys_alias,
                    device_id: this.deviceInfo.device_id
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.setDeviceMsg(params, data => {
                    this.msgTool.loading = false;
                    this.msgTool.show = false;
                    if (data.status_code === "SUCCEEDED") {
                        this.$message.success("发送成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            }
        }
    };
</script>

<style scoped>
    /*动画 */

    .xxx {
        transition: all 0.3s;
    }

    .header {
        position: fixed;
        top: 0;
        width: 100%;
        line-height: 80px;
        z-index: 9;
        background: #2D3545;
        height: 100px;
        color: white;
        width: 100%;
        /* 解决抖动黑科技 */
        transform: translateZ(0);
        font-size: 30px;
    }

    .header > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        margin: 0 30px;
    }

    .title {
        text-align: center;
    }

    .iconfont {
        color: #ffffff;
        cursor: pointer;
    }

    .logo {
        display: flex;
        align-items: center;
        /*flex: 1;*/
    }

    .logo > i {
        font-size: 40px;
        cursor: pointer;
    }

    .logo img {
        width: 100px;
    }

    .msg-menu {
        position: absolute;
        top: 38px;
        right: 0px;
        width: 320px;
    }
    .user-avatar {
        position: relative;
    }
    .user-avatar img {
        width: 33px;
        border-radius: 50%;
        border: 1px solid #ccc;
        position: absolute;
        left: -40px;
        top: 20px;
    }

    .tool-tip {
        display: flex;
        align-items: center;
    }

    .tool-tip > * {
        margin: 0 15px;
    }

    .msg-tool-button {
        /*background: rgba(84,84,84,1);*/
        position: relative;
    }

    .msg-tool {
        background: rgba(84, 84, 84, 1);
        border-radius: 5px;
        position: absolute;
        top: 60px;
        left: -500px;
        /*width: 700px;*/
        display: flex;
        padding: 10px;

        align-items: center;
    }

    .msg-tool > div button {
        color: white;
    }

    .msg-tool > div:first-child {
        width: 500px;
    }

    .msg-tool > div:last-child {
        width: 100px;
        text-align: center;
        cursor: pointer;
    }
    .toggleMsgTool{
        background: rgb(84, 84, 84);
        display: inline;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    @media (max-width: 900px) {
        .header {
            height: 50px;
            line-height: 30px;
            font-size: 20px;
        }

        .header > div {
            margin: 0 15px;
        }

        .logo {
            font-size: 16px;
        }
        .logo>p{
            max-width: 250px;
            overflow: hidden;
            white-space: nowrap;
        }

        .logo > i {
            font-size: 30px;
        }

        .msg-tool {
            background: rgba(84, 84, 84, 1);
            border-radius: 5px;
            position: fixed;
            top: 60px;
            left: 3%;
            display: flex;
            padding: 10px;
            width: 90%;
            align-items: center;
        }

        .msg-tool > div:first-child {
            width: 85%;
        }

        .msg-tool > div:last-child {
            width: 15%;
            text-align: center;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// MpageHead.vue?1d578a5e